import React from 'react';
import PaginatedPrioritySection from './PaginatedPrioritySection';
import EditableText from './EditableText';

export default function TopStrengthsPage({ data, personName, startPageNumber, reportType = 'standard' }) {
  const header = (
    <>
      <h2 className="pdf-section-heading pdf-section-heading--numbered">
        <span className="pdf-section-heading__badge">2</span>
        <EditableText
          as="span"
          path="topStrengths.sectionHeading"
          variant="inline"
          stripInlineWrap
        />
      </h2>
      <EditableText
        as="div"
        className="pdf-body-text"
        path="topStrengths.topStrengthsReport"
        variant="block"
      />
      {reportType === 'trend' && (
        <EditableText
          as="p"
          className="pdf-note pdf-note--trend-strengths"
          path="topStrengths.trendNote"
          variant="block"
          stripInlineWrap
          fallback="Note: Time 1 perception for each behavior is shown in the grey circles and the line connecting Time 1 with Time 2 shows how the perception has shifted over time."
        />
      )}
    </>
  );

  return (
    <PaginatedPrioritySection
      header={header}
      tableContents={data.tableContents}
      legendKeys={data.tableContents && data.tableContents.legendKeys && data.tableContents.legendKeys}
      summaryContentPath="topStrengths.topStrengthsContent"
      slicePageContent="topStrengths"
      sectionKey="topStrengths"
      startPageNumber={startPageNumber}
      personName={personName}
      reportType={reportType}
    />
  );
}
